if($('footer#footer').length){
    $('#signature').append('<span class="sigantureFirm"> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span> ')
    //$('footer#footer').after($('.footer-bottom'))
    $('footer#footer').before($('footer#footer .CustomInstagram'))    
    $(".instagram-widget>a").each(function(){
        $(".CustomInstagram .igFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
    $('.custom-footer__contact h4 span').text('Sociální sítě')
}